import React, { useContext } from "react";
import { GlobalContext } from "@/contexts/SiteDataContext";
import Richtext from "@/components/organisms/Legacy/Richtext";
import IconDS11 from "../../../assets/svg/icon-form-ds11.svg";
import IconDS64 from "../../../assets/svg/icon-form-ds64.svg";
import IconDS82 from "../../../assets/svg/icon-form-ds82.svg";
import IconDS5504 from "../../../assets/svg/icon-form-ds5504.svg";
import "./styles.scss";

const iconForms: Record<string, React.ComponentType> = {
  "DS-11": IconDS11,
  "DS-64": IconDS64,
  "DS-82": IconDS82,
  "DS-5504": IconDS5504,
};

const titles: Record<string, string> = {
  "DS-11": "New Passport",
  "DS-82": "Passport Renewal",
  "DS-64": "Lost or Stolen Passport",
  "DS-5504": "Changes, Corrections or Limited Passport",
};

interface RequirementsProps {
  data: any;
}

const Requirements = ({ data }: RequirementsProps) => {
  const {
    name,
    requeriments: { json: requirements },
  } = data;
  const title = titles[name];
  const FormIcon = iconForms[name];
  const { t } = useContext(GlobalContext).context;

  return (
    <>
      <div className="requirements-card u-box u-box--small">
        <div className="requirements-card__header">
          <div className="requirements-card__headerIcon">
            <FormIcon />
          </div>
          <div>
            <div className={"requirements-card__header-title"}>
              <b>{t[title]}</b>
            </div>
            <div className={"requirements-card__header-subtitle"}>
              <b>{name}</b>
            </div>
          </div>
        </div>
        <div className=""></div>
        <div className="richText">
          <Richtext
            content={requirements}
            t={t}
          />
        </div>
      </div>
    </>
  );
};
export default Requirements;
